import { render, staticRenderFns } from "./YLayoutBodyMenu.vue?vue&type=template&id=086f4559&scoped=true&"
import script from "./YLayoutBodyMenu.vue?vue&type=script&lang=js&"
export * from "./YLayoutBodyMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086f4559",
  null
  
)

export default component.exports